import React, { Component } from "react";
import {
  CardMedia,
  withStyles,
  Grid,
  Card,
  Typography,
  Select,
  Menu,
  MenuItem,
  InputBase,
  Avatar,
  Paper,
  CardContent,
  Button,
  LinearProgress,
  Popover,
} from "@material-ui/core";
import * as ApiEndPoints from "../../../../managers/api/ApiEndPoints";
import * as ApiManager from "../../../../managers/api/ApiManager";
import { ConfirmBookingStyles } from "../../../styles";
import DialogSupport from "./DialogSupport";
import DialogCancelReasons from "./DialogCancelReasons";

class ConfirmBooking extends Component {
  state = {
    data: "",
    buttonData: null,
    isLoading: false,
    showSupportDialog: false,
    showCancelReasonDialog: false,
  };

  getMapSizeImage(image) {
    let image1 = image.split("&size");
    return image1[0] + "&size=400x200";
  }
  componentDidMount() {
    this.setState({ isLoading: true });
    ApiManager.callPostApi(
      "ConfirmBooking",
      "Specific details",
      ApiEndPoints.APPORIO_TAXI_APIS.USER_SPECIFIC_DETAILS,
      {
        booking_id: this.props.bookingId,
      }
    )
      .then((res) => {
        if (res.result === "1") {
          this.setState({
            isLoading: false,
            data: res.data,
            buttonData: res.data.button_visibility,
          });
        } else {
          this.setState({ isLoading: false });
          alert(JSON.stringify(res.message));
        }
      })

      .catch((err) => alert(JSON.stringify(err)));
  }

  _sendEmail = () => {
    this.props.showLoader(true);
    ApiManager.callPostApi(
      "ConfirmBooking",
      "Invoice Email",
      ApiEndPoints.APPORIO_TAXI_APIS.USER_BOOKING_EMAIL + this.props.bookingId,
      {}
    )
      .then((res) => {
        if (res.result === "1") {
          this.props.showSnackbar("" + res.message);
        } else {
          this.setState({ isLoading: false });
          alert(JSON.stringify(res.message));
        }
      })

      .catch((err) => alert(JSON.stringify(err)));
  };

  _callSupportApi = (data) => {
    this.props.showLoader(true);

    ApiManager.callPostApi(
      "ConfirmBooking",
      "Customer Support",
      ApiEndPoints.APPORIO_TAXI_APIS.USER_CUSTOMER_SUPPORT,
      data
    )
      .then((res) => {
        this.props.showLoader(false);
        if (res.result == "1") {
          this.setState({ showSupportDialog: false });
          this.props.showSnackbar("" + res.message);
        } else {
          alert(JSON.stringify(res.message));
        }
      })

      .catch((err) => alert(JSON.stringify(err)));
  };

  _callCancelApi = (data) => {
    //  alert(JSON.stringify(data));
    let body = {
      booking_id: this.props.bookingId,
      cancel_reason_id: data.id,
      cancel_charges: data.cancelCharges,
    };
    this.props.showLoader(true);

    ApiManager.callPostApi(
      "ConfirmBooking",
      "Cancel Ride",
      ApiEndPoints.APPORIO_TAXI_APIS.USER_TRIP_CANCEL,
      body
    )
      .then((res) => {
        this.props.showLoader(false);
        if (res.result == "1") {
          this.setState({ showSupportDialog: false });
          //this.props.showSnackbar("" + res.message);
          this.props.onRideCancel("" + res.message);
        } else {
          alert(JSON.stringify(res.message));
        }
      })

      .catch((err) => alert(JSON.stringify(err)));
  };

  render() {
    const { classes } = this.props;
    if (this.state.isLoading) {
      return (
        <div
          className={classes.WidthDialoginner}
          style={{
            width: "40vw",
            height: "90vh",
            borderRadius: 15,
            position: "relative",
            marginBottom: "15%",
            justifyContent: "center",
          }}
        >
          <LinearProgress />
        </div>
      );
    }
    return (
      <div
        className={classes.WidthDialoginner}
        style={{
          width: "40vw",
          height: "90vh",
          borderRadius: 15,
          position: "relative",
          marginBottom: "15%",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        {this.state.isLoading ? (
          <div
            className={classes.WidthDialoginner}
            style={{
              width: "40vw",
              height: "90vh",
              borderRadius: 15,
              position: "relative",
              marginBottom: "15%",
            }}
          >
            <LinearProgress />
          </div>
        ) : (
          this.state.data != "" && [
            console.log(
              JSON.stringify(this.state.data.holder_map_image.data.map_image)
            ),

            <img
              src={this.getMapSizeImage(
                this.state.data.holder_map_image.data.map_image
              )}
              // image="https://maps.googleapis.com/maps/api/staticmap?size=900x500&path=enc%3AohqfIc_jpCkE%7DCx%40mJdDa%5BbD%7BM%7D%40e%40_MgKiQuVOoFlF%7DVnCnBn%40aDlDkN%7DDwEt%40%7DM%7DB_TjBy%7C%40lEgr%40lMa%60BhSi%7C%40%7COmuAxb%40k%7BGh%5E_%7BFjRor%40%7CaAq%7DC~iAomDle%40i%7BA~d%40ktBbp%40%7DqCvoA%7DjHpm%40uuDzH%7Dm%40sAg%7DB%60Bgy%40%7CHkv%40tTsxAtCgl%40aBoeAwKwaAqG%7B%5CeBc_%40p%40aZx%60%40gcGpNg%7CBGmWa%5CgpFyZolF%7BFgcDyPy%7CEoK_%7BAwm%40%7BqFqZaiBoNsqCuNq%7BHk%60%40crG%7B%5DqkBul%40guC%7BJ%7D%5DaNo%7B%40waA%7DmFsLc_%40_V%7Dh%40icAopBcd%40i_A_w%40mlBwbAiiBmv%40ajDozBibKsZ%7DvAkLm%5DysAk%7DCyr%40i%60BqUkp%40mj%40uoBex%40koAk_E_hG%7B%60Ac%7DAwp%40soAyk%40ogAml%40%7Bg%40qKsNeJw%5DeuA%7D%60Fkm%40czBmK%7Bg%40wCed%40b%40_e%40dT%7BgCzx%40csJrc%40ejFtGi%60CnB_pFhCa%60Gw%40%7Du%40wFwaAmP%7BoA%7Dj%40etBsRm_AiGos%40aCyy%40Lic%40tFohA~NeoCvC_%7CAWm~%40gb%40w~DuLex%40mUk_Ae_%40o_Aol%40qmAgv%40_%7DAaf%40qhAkMcl%40mHwn%40iCuq%40Nqi%40pF%7D%7CE~CyiDmFkgAoUedAcb%40ku%40ma%40cl%40mUko%40sLwr%40mg%40awIoA_aApDe~%40dKytAfw%40kyFtCib%40%7DA%7Bj%40kd%40usBcRgx%40uFwb%40%7BCulAjJmbC~CumAuGwlA_%5Du_C_PqyB%7BI%7DiAwKik%40%7DUcr%40ya%40up%40%7DkB%7DoCoQ%7Da%40aMyf%40an%40wjEimBuwKiYybC%7DLuyBoJ%7DhBuMieAwd%40i%7BB%7B~%40g%60D_Si%5Dsi%40%7Bk%40cPeSuH_T%7DNct%40kNcmC_Gyr%40mq%40_~AkmA%7DkCksByrE_N%7Bc%40oAcs%40%60J%7Bi%40t%7DByaHxNqt%40tGgxA%7CJ%7BkGeJ_aDsQi_HmFwuAmI%7BdA_XijByFgv%40%7DAiwBxDocAdM%7BlAtSmcAfUmaAptAmbGh~AcvGbwBc%7DHff%40shB~Isp%40nQu%7DB%60UsuCbBok%40l%40%7DzAhIwbA~OuaAnYwp%40rYwe%40%7CNke%40zc%40%7BhBrOwRdo%40sf%40xNaTb_%40uy%40ta%40k~%40xTap%40hl%40uiCre%40unHlIi~AlFsc%40rEkk%40aAce%40mL%7DlAwPcyB_GohBzDsqAtMqtA~h%40weDtFkd%40Bi%60%40_XwfEdAag%40dEkM%60%40zAqApJef%40%7BP_o%40sYys%40ai%40yf%40_j%40y_%40oi%40mVi%5EmFqSwAiPtDuQbc%40_nAtZyaAlEkc%40r%40eq%40%7CAo%5BrTwcAtVuz%40vQ%7Dd%40%7CPmb%40xT%7B%5CzZyd%40jG%7BRzL%7Dh%40jr%40ov%40rFiImFqPiD%7BJ&key=AIzaSyA8M9gAGweshJ74YNfYBrPf4SjxIoWED8E&zoom=7"
              style={{
                width: "100%",
                backgroundSize: "100%",
              }}
            />,
            <Grid item xs={12}>
              {this.state.data.holder_pickdrop_location.visibility && (
                <Grid item xs={12}>
                  <Grid
                    container
                    xs={12}
                    style={{
                      padding: 5,

                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: 10 / 2,
                        background: "#40D590",
                      }}
                    />
                    <Typography
                      noWrap={true}
                      style={{
                        padding: 5,
                        fontSize: 14,

                        fontWeight: 400,
                      }}
                    >
                      {this.state.data.holder_pickdrop_location.data.pick_text}
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    xs={12}
                    style={{
                      padding: 5,

                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        width: 10,
                        height: 10,
                        borderRadius: 10 / 2,
                        background: "#EF4742",
                      }}
                    />
                    <Typography
                      noWrap={true}
                      style={{ fontSize: 14, padding: 5, fontWeight: 400 }}
                    >
                      {this.state.data.holder_pickdrop_location.data.drop_text}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              <Grid container xs={12} style={{ margin: "2%" }}>
                <Grid item xs={12} md={1}>
                  <Avatar
                    src={this.state.data.holder_driver.circular_image}
                    style={{ width: 50, height: 50 }}
                  />
                </Grid>
                <Grid item xs={7} style={{ marginLeft: 10 }}>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    {this.state.data.holder_driver.data.highlighted_text}
                  </Typography>
                  <Typography style={{ fontSize: 14 }}>
                    {this.state.data.holder_driver.data.small_text}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography style={{ fontSize: 12, fontWeight: "bold" }}>
                    Rating Driver
                  </Typography>

                  <Typography style={{ fontSize: 12 }}>
                    {this.state.data.holder_driver.data.rating}
                  </Typography>
                </Grid>
              </Grid>

              {this.state.data.holder_metering.visibility && [
                <hr />,

                <Grid
                  container
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    padding: 5,
                  }}
                >
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    {this.state.data.holder_metering.data.text_one}
                  </Typography>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    {this.state.data.holder_metering.data.text_two}
                  </Typography>
                  <Typography style={{ fontSize: 14, fontWeight: "bold" }}>
                    {this.state.data.holder_metering.data.text_three}
                  </Typography>
                </Grid>,
                <hr />,
              ]}

              {this.state.data.holder_receipt.visibility && (
                <Grid item xs={12} style={{ padding: 10 }}>
                  {this.state.data.holder_receipt.data.map((val, index) => (
                    <Grid
                      container
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {val.highlighted_visibility && (
                        <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                          {val.highlighted_text}
                        </Typography>
                      )}
                      {val.small_text_visibility && (
                        <Typography style={{ fontSize: 14 }}>
                          {val.small_text}
                        </Typography>
                      )}

                      {val.value_textvisibility && (
                        <Typography style={{ fontSize: 14 }}>
                          {val.value_text}
                        </Typography>
                      )}

                      {/* <Typography style={{ fontSize: 14 }}>12.09</Typography> */}
                    </Grid>
                  ))}
                </Grid>
              )}
            </Grid>,
          ]
        )}

        {this.state.buttonData ? (
          <Paper
            style={{
              width: "100%",
              display: "flex",
              position: "fixed",

              bottom: 0,
              justifyContent: "space-around",
            }}
          >
            <CardMedia
              justify="center"
              item
              style={{
                margin: "1%",
                display: this.state.buttonData.track ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="data:image/png;base64,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"
                style={{ width: 30, height: 30 }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Tracking
              </Typography>
            </CardMedia>

            <CardMedia
              justify="center"
              item
              style={{
                margin: "1%",

                display: this.state.buttonData.cancel ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => this.setState({ showCancelReasonDialog: true })}
            >
              <img
                src="https://image.flaticon.com/icons/svg/149/149147.svg"
                style={{ width: 30, height: 30 }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Cancel
              </Typography>
            </CardMedia>

            <CardMedia
              justify="center"
              item
              style={{
                margin: "1%",
                display: this.state.buttonData.mail_invoice ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={this._sendEmail}
            >
              <img
                src="https://image.flaticon.com/icons/svg/181/181535.svg"
                style={{ width: 30, height: 30 }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Mail Invoice
              </Typography>
              {/* <Popover
                id={true ? "simple-popover" : undefined}
                open={true}
                anchorEl={"hello"}
                onClose={() => {
                  // this.setState({ [anchorEl]: null });
                }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center"
                }}
              >
                <Typography>Popover</Typography>
              </Popover> */}
            </CardMedia>

            <CardMedia
              justify="center"
              item
              style={{
                margin: "1%",
                display: this.state.buttonData.support ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => this.setState({ showSupportDialog: true })}
            >
              <img
                src="https://image.flaticon.com/icons/svg/685/685823.svg"
                style={{ width: 30, height: 30 }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Support
              </Typography>
            </CardMedia>

            <CardMedia
              justify="center"
              item
              style={{
                margin: "1%",
                display: this.state.buttonData.coupon ? "flex" : "none",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src="https://image.flaticon.com/icons/svg/879/879757.svg"
                style={{ width: 30, height: 30 }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
                Coupon
              </Typography>
            </CardMedia>
          </Paper>
        ) : null}

        {this.state.showSupportDialog ? (
          <DialogSupport
            open={this.state.showSupportDialog}
            onClose={() => {
              this.setState({ showSupportDialog: false });
            }}
            onOk={this._callSupportApi}
          />
        ) : null}
        {this.state.showCancelReasonDialog ? (
          <DialogCancelReasons
            open={this.state.showCancelReasonDialog}
            onClose={() => {
              this.setState({ showCancelReasonDialog: false });
            }}
            booking_id={this.props.bookingId}
            onOk={this._callCancelApi}
            showMsg={(msg, status) => {
              this.props.showSnackbar(msg, status);
            }}
          />
        ) : null}
      </div>
    );
  }
}

// export default ConfirmBooking;
export default withStyles(ConfirmBookingStyles)(ConfirmBooking);
